export enum VisualElementDefaultType {
    MESH = "mesh",
    LINE = "line",
    POINT = "point",
    TEXT = "text",
    ARROW = "arrow",
    TRANSFORM = "transform",
    RAYCAST = "raycast",
    TORUS = "torus"
}